import { VyEmptyState } from '../../components/new-design/data-display/VyEmptyState';

export const EmptyPage = () => {
  return (
    <VyEmptyState title="Data will show up here once customers and contracts are created" description="" />
  );
};
